import React from "react";
import DatePicker from "react-datepicker";
import { Controller } from "react-hook-form";
import { Input, Box } from "@chakra-ui/react";
import "react-datepicker/dist/react-datepicker.css";
import { Field } from "../../ui/field";
import { useColorMode, useColorModeValue } from "../../ui/color-mode";
import './styles.css';
import { darkMode, lightMode } from "../../../theme/config";


export const DatePickerBox = (props) => {
  const { label, control, invalid, errorText, name = "date", placeholderText = "DD/MM/YYYY", dateFormat = "dd/MM/yyyy", size = "md" } = props;
  const theme = useColorMode();
  const backgoundColor = useColorModeValue(lightMode.boxBackgroundColor, darkMode.boxBackgroundColor)

  return (
    <Field label={label} invalid={invalid} errorText={errorText}>
      <Controller
        control={control}
        name={name}
        render={({ field: { ref, ...field } }) => {
          return (
            <Box width="100%">
              <DatePicker
                {...field}
                selected={field?.value instanceof Date ? field.value : null}
                onChange={(date) => field.onChange(date)}
                placeholderText={placeholderText}
                dateFormat={dateFormat}
                customInput={<Input width="100%" size={size} bg={backgoundColor} />}
                popperClassName={theme.colorMode === "dark" ? "datepicker-dark" : "datepicker-light"}
                maxDate={new Date()}
                dayClassName={(date) =>
                  date > new Date() ? 'disabled-day' : undefined
                }
              />
            </Box>
          )
        }}
      />
    </Field>
  );
};


export const TimePickerBox = (props) => {
  const { label, control, invalid, errorText, name = "time", placeholderText = "HH:mm", timeFormat = "HH:mm", timeIntervals = 15, size = "md" } = props;
  const theme = useColorMode();

  return (
    <Field label={label} invalid={invalid} errorText={errorText}>
      <Controller
        control={control}
        name={name}
        render={({ field: { ref, ...field } }) => {
          return (
            <Box width="100%">
              <DatePicker
                {...field}
                selected={field?.value instanceof Date ? field.value : null} // If the field is empty, it should be null
                onChange={(time) => field.onChange(time)} // Time on change
                placeholderText={placeholderText}
                dateFormat={timeFormat} // Only show time format
                customInput={<Input width="100%" size={size} />}
                popperClassName={theme.colorMode === "dark" ? "timepicker-dark" : "timepicker-light"}
                showTimeSelect // Only show the time picker, no date
                showTimeSelectOnly // Make sure only time is shown, no date
                timeFormat={timeFormat} // Define time format (e.g., HH:mm)
                timeIntervals={timeIntervals} // 15-minute intervals
              />
            </Box>
          );
        }}
      />
    </Field>
  );
};


